import Model from '../model'
import Enum from '../enums'

import ContentTemplate from './contentTemplate'

export default class ServiceAutomation extends Model {
  static modelName () {
    return 'serviceAutomation'
  }

  objectID () {
    return this.idServiceAutomation
  }

  relations () {
    return {
      automation: { type: ContentTemplate },
      frequency: { type: ServiceAutomationFrequency },
      requirementMode: { type: ServiceAutomationRequirementMode },
      type: { type: ServiceAutomationType },
    }
  }

  get scheduleOffsetMode () {
    return this.scheduleOffset > -1 ? 'after' : 'before'
  }

  set scheduleOffsetMode (value) {
    const isBefore = value === 'before'

    if (isBefore) {
      this.scheduleOffset = -Math.abs(this.scheduleOffset)
    } else {
      this.scheduleOffset = Math.abs(this.scheduleOffset)
    }
  }

  get scheduleOffsetValue () {
    return Math.abs(this.scheduleOffset)
  }

  set scheduleOffsetValue (value) {
    const isBefore = this.scheduleOffsetMode === 'before'

    if (isBefore) {
      this.scheduleOffset = -Math.abs(value)
    } else {
      this.scheduleOffset = Math.abs(value)
    }
  }

  get isRequirementModeScheduled () {
    return this.requirementMode === ServiceAutomationRequirementMode.scheduled
  }
}

export const ServiceAutomationType = new Enum({
  message: { value: 1, description: 'general.message' },
})

export const ServiceAutomationFrequency = new Enum({
  reservation: { value: 0, description: 'service.form.frequency.reservation' },
  customer: { value: 1, description: 'service.form.frequency.customer' },
  service: { value: 2, description: 'service.form.frequency.service' },
})

export const ServiceAutomationRequirementMode = new Enum({
  confirmation: { value: 0, description: 'service.form.requirement.confirmation' },
  scheduled: { value: 1, description: 'service.form.requirement.scheduled' },
  internal: { value: 2, description: 'service.form.requirement.internal' },
})
